import { ChangeDetectionStrategy, Component, inject, Injector, ViewEncapsulation } from '@angular/core';
import { AuthFormComponent, AuthHeaderComponent } from '../../components';
import { CredentialsDTO } from '../../application/models';
import { Router } from '@angular/router';
import { AppRoutes, MODAL_TOKEN, ModalProvider, PLATFORM_TOKEN, PlatformProvider, PresentModalComponent } from '@core';
import { NgClass } from '@angular/common';
import { LoginCommandHandler } from '../../application/handlers';
import { getFirebaseAuthErrorMessage, redirectAfterLoginUtil } from '../../application/utils';

@Component({
  templateUrl: './login.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [AuthFormComponent, AuthHeaderComponent, NgClass]
})
export class LoginPage {
  private readonly loginCommandHandler: LoginCommandHandler = inject(LoginCommandHandler);
  private readonly router: Router = inject(Router);
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  private readonly injector: Injector = inject(Injector);

  readonly isiOS: boolean = this.platformProvider.isiOS;

  login(event: CredentialsDTO): void {
    this.loginCommandHandler
      .login({
        email: event.email?.trim(),
        password: event.password
      })
      .subscribe({
        next: () => {
          redirectAfterLoginUtil(this.injector);
        },
        error: (err: unknown) => this.errorLogin(err)
      });
  }

  goBack(): void {
    this.router.navigate([`/${AppRoutes.AUTH}`]);
  }

  private errorLogin(err: unknown): void {
    const { header, message } = getFirebaseAuthErrorMessage(err, 'Logowanie');
    this.modalProvider.showModal$({
      component: PresentModalComponent,
      componentProps: {
        header,
        message,
        btnTxt: 'Zamknij'
      },
      cssClass: 'present-modal'
    });
  }
}
